import { Routes } from '@angular/router';

import {
    authGuard,
    customerAccessGuard,
    internalUserGuard,
    preferredCustomerGuard,
} from '@advania-cosoftware/wolf-core';

import { customerRoutes } from './features/customer/customer.routes';
import { internalRoutes } from './features/internal/internal.routes';
import { AuthenticatedSessionLayout } from './features/sessions/pages/authenticated-session/authenticated-session.layout';

export const routes: Routes = [
    {
        path: 'login',
        loadComponent: () => import('./features/sessions/pages/login/login.page').then((module) => module.LoginPage),
    },
    {
        path: 'internal',
        component: AuthenticatedSessionLayout,
        data: { workspace: 'internal', customerNumber: '' },
        canActivate: [authGuard, internalUserGuard],
        children: internalRoutes,
    },
    {
        path: ':customerNumber',
        component: AuthenticatedSessionLayout,
        data: { workspace: 'customer' },
        canActivate: [authGuard, customerAccessGuard],
        runGuardsAndResolvers: 'pathParamsChange',
        children: customerRoutes,
    },
    {
        path: '',
        pathMatch: 'full',
        canActivate: [authGuard, preferredCustomerGuard],
        loadComponent: () =>
            import('./features/sessions/pages/customer-picker/customer-picker.component').then(
                (module) => module.CustomerPickerComponent,
            ),
    },
    { path: '**', redirectTo: '' },
];
